import { Component, OnInit, Inject } from '@angular/core';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-edit-company-quota',
  templateUrl: './edit-company-quota.component.html',
  styleUrls: ['./edit-company-quota.component.scss']
})
export class EditCompanyQuotaComponent implements OnInit {

  public editCompanyQuotaForm: FormGroup;

  constructor(public dialogRef: MdDialogRef<EditCompanyQuotaComponent>,
              @Inject(MD_DIALOG_DATA) public data: any,
              private formBuilder: FormBuilder) { }

  ngOnInit() {
    this.editCompanyQuotaForm = this.formBuilder.group({
      option: [ Number.isInteger(this.data.quota) ? 'quota' : 'apiKey', Validators.required ],
      quota: [ this.data.quota ],
      apiKey: [ this.data.apiKey ]
    });
  }

  public onCancelClick(): void  {
    this.dialogRef.close();
  }

  public onSaveClick(quotaData): void {
    if (quotaData.option === 'quota') {
      this.dialogRef.close({
        quota: quotaData.quota,
        apiKey: undefined
      });
    } else {
      this.dialogRef.close({
        quota: undefined,
        apiKey: quotaData.apiKey
      });
    }
  }

  public isFromValid(quotaData): boolean {
    if (quotaData.option === 'quota') {
      return Number.isInteger(quotaData.quota);
    } else {
      return !!quotaData.apiKey;
    }
  }

  public isQuota(): boolean {
    return this.editCompanyQuotaForm.value.option === 'quota';
  }

  public isAPIKey(): boolean {
    return this.editCompanyQuotaForm.value.option === 'apiKey';
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/admin/components/my-organisation/components/edit-company/edit-company-quota.component.ts